/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';
import { SimpleProduct } from '@msdyn365-commerce/retail-proxy';
import { getByIdsAsync } from '@msdyn365-commerce/retail-proxy/dist/DataActions/ProductsDataActions.g';
/**
 * GetProductAttributesCartlines Input Action
 */
export class GetProductsInput implements Msdyn365.IActionInput {
    public productIDs: number[];
    constructor(productID: number[]) {
        this.productIDs = productID;
    }

    // a cache object type and an appropriate cache key
    public getCacheKey = () => `getProductsByIdsAsync`;
    public getCacheObjectType = () => 'getProductsByIdsAsync';
    public dataCacheType = (): Msdyn365.CacheType => 'none';
}

// TODO: Create a data model here or import one to capture the response of the action
export interface IGetProducts {
    products: SimpleProduct[];
}

/**
 * TODO: Use this function to call your action and process the results as needed
 */
export async function getProductsActions(input: GetProductsInput, ctx: Msdyn365.IActionContext): Promise<IGetProducts> {
    const channelID = +ctx.requestContext.apiSettings.channelId;

    const getProductsResponse = await getByIdsAsync({ callerContext: ctx }, channelID, input.productIDs);
    return { products: getProductsResponse };
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IGetProducts>>getProductsActions,
    id: 'getProductsByIdsAsync'
});
